import ActionTypes from '../actions/types'
import { createReducer } from 'reduxsauce'
import Utils from '../utils/Utils'

const INITIAL_STATE = {
  events: []
}

const setEvents = (state, action) => {
  const { events } = action.payload
  const newEvents = events
    .filter(event => event.id)
    .map(event => ({
      ...event,
      start: event.start || 0,
      end: event.end || 0
    }))
  return {
    ...state,
    events: newEvents
  }
}

const addEvent = (state, action) => {
  const { event } = action.payload
  const newEvents = [...state.events, event]
  return {
    ...state,
    events: newEvents
  }
}

const removeEvent = (state, action) => {
  const { eventId } = action.payload
  const newEvents = state.events.filter(event => event.id !== eventId)
  return {
    ...state,
    events: newEvents
  }
}

const updateEvent = (state, action) => {
  const { eventId, event } = action.payload
  const eventIndex = Utils.getIndexOfObjectWithId(state.events, eventId)

  let newEvents

  // New event
  if (eventIndex === -1) {
    newEvents = [...state.events, event]
  } else {
    // Update existing event
    newEvents = state.events.map((e, index) =>
      index === eventIndex ? event : e
    )
  }

  return {
    ...state,
    events: newEvents
  }
}

const ACTION_HANDLERS = {
  [ActionTypes.SET_CALENDAR_EVENTS]: setEvents,
  [ActionTypes.ADD_CALENDAR_EVENT]: addEvent,
  [ActionTypes.REMOVE_CALENDAR_EVENT]: removeEvent,
  [ActionTypes.UPDATE_CALENDAR_EVENT]: updateEvent
}

export default createReducer(INITIAL_STATE, ACTION_HANDLERS)
